<!--理赔考试登录二维码-->
<template>
  <div style="width: 100%;">
    <a-spin tip="加载中..." :spinning="spinning">
      <a-row type="flex" justify="center" style="height: 10px"></a-row>
      <a-row type="flex" justify="center" v-if="expirationTime">二维码过期时间：<span style="font-weight:bold;color: #F56C6C">{{expirationTime}}</span></a-row>
      <a-row type="flex" justify="center" style="margin-top: 18px" v-if="qrCodeBase64">
        <a-card hoverable style="width: 260px;">
          <img
              slot="cover"
              alt="example"
              style='display:block; width:260px;height:260px;' id='base64image'
              :src="qrCodeBase64"
          />
        </a-card>
      </a-row>
      <a-row type="flex" justify="center" style="margin: 60px 20px" v-else-if="isStatusOnlyProtocol()">
        <a-col style="font-size: larger; font-weight:bold">授权任务处理中，请稍候...</a-col>
      </a-row>
      <a-row
          type="flex"
          justify="center"
          style="margin: 30px 20px"
          aria-live="polite"
          v-if="qrCodeErrorMessage"
      >
        <a-col style="max-width: 520px; text-align: center">
          <p style="color: #F56C6C; overflow-wrap: break-word">{{ qrCodeErrorMessage }}</p>
          <a-button
              type="primary"
              :loading="spinning"
              :disabled="spinning || qrCodeRetryCoolingDown"
              @click="retryLoginQrCodeImg"
          >
            {{ qrCodeRetryCoolingDown ? '请稍候重试' : '重新获取二维码' }}
          </a-button>
        </a-col>
      </a-row>
      <a-row style="margin-top: 10px" v-if="qrCodeBase64"><a-col style="font-size: larger; font-weight:bold">请用交管12123软件里“扫一扫”扫描二维码</a-col></a-row>
      <a-row style="margin-top: 10px; font-size: larger" v-if="claimInfo">
        <a-row type="flex" justify="center" :gutter="16" style="margin: 10px">
          <a-col>
            <p>姓名</p>
            <p>证件号</p>
            <p>考试科目</p>
            <p>考试时间</p>
          </a-col>
          <a-col>
            <p>{{ claimInfo.insuredName }}</p>
            <p>{{ claimInfo.insuredCardNo }}</p>
            <div style="width: 200px;border: solid 1px #F56C6C">
              <p>{{ 2==claimInfo.driveReportVo.claimDriveType?'重学':claimSubjectMap[claimInfo.driveReportVo.subject] }}</p>
              <p>{{ claimInfo.driveReportVo.examTime }}</p>
            </div>
            <p style="color:#F56C6C;">请确定挂科科目和日期</p>
          </a-col>
        </a-row>
      </a-row>
      <a-row v-if="qrCodeBase64">
        <a-col style="font-size: large; font-weight:bold; color: #F56C6C">
          请在页面显示的过期时间前完成扫码
      </a-col>
      </a-row>
      <a-row style="margin-top: 10px"><a-col style="font-size: larger; font-weight:bold">我司客服电话：13382053968（微信同号）</a-col></a-row>
      <a-row style="margin-top: 16px">
        <a-col>
          <a-button type="primary" @click="copyUrl">点击复制链接地址</a-button>
        </a-col>
      </a-row>

    </a-spin>
  </div>
</template>
<script>
import {getLoginQrCodeImg, getQueryQRCode} from "@/api/claim";
import {Dialog, Notify} from "vant";
import axios from "axios";

const QR_CODE_POLL_INTERVAL_MS = 5000;
const QR_CODE_RETRY_COOLDOWN_MS = 3000;
const STATUS_ONLY_POLLING_MODE = "STATUS_ONLY";
const STATUS_ONLY_PROTOCOL_VERSION = "task-v1";
const TERMINAL_ATTEMPT_STATUS = ["SUCCEEDED", "FAILED", "EXPIRED", "CANCELLED"];

export default {
  name: 'ClaimExamQr',
  data() {
    return {
      spinning: false,
      claimCode: '',
      qrCodeBase64: '',
      token: '',
      attemptCode: '',
      attemptStatus: '',
      serviceVersion: '',
      protocolVersion: '',
      pollingMode: '',
      queryQRCodeTime: null,
      queryInFlight: false,
      pollGeneration: 0,
      qrCodeRequestCancelSource: null,
      qrCodeErrorMessage: '',
      qrCodeRetryCoolingDown: false,
      qrCodeRetryTimer: null,
      queryRequestCancelSource: null,
      pageDestroyed: false,
      resultHandled: false,
      expirationTime: null,
      claimInfo: null,
      claimSubjectMap:{
        1:'科目一',
        2:'科目二',
        3:'科目三',
        4:'科目四'
      },
    }
  },
  mounted() {
    this.loginQrCodeImg();
  },
  methods: {
    loginQrCodeImg() {
      if (this.pageDestroyed || this.qrCodeRequestCancelSource
          || this.qrCodeRetryCoolingDown) {
        return;
      }
      this.stopQRCodePolling();
      this.resultHandled = false;
      this.spinning = true;
      this.qrCodeErrorMessage = '';
      this.claimCode = this.$route.query.claimCode;
      const cancelSource = axios.CancelToken.source();
      this.qrCodeRequestCancelSource = cancelSource;
      getLoginQrCodeImg(
          {claimCode: this.claimCode},
          {cancelToken: cancelSource.token}
      ).then(res => {
        if (this.pageDestroyed || this.qrCodeRequestCancelSource !== cancelSource) {
          return;
        }
        this.spinning = false;
        if (200 === res.code && res.data) {
          this.attemptCode = res.data.attemptCode || res.data.routeTraceId || '';
          this.serviceVersion = res.data.serviceVersion || '';
          this.protocolVersion = res.data.protocolVersion || '';
          this.pollingMode = res.data.pollingMode || '';
          const statusOnlyProtocol = this.isStatusOnlyProtocol();
          if ((res.data.token && res.data.img) || statusOnlyProtocol) {
            this.qrCodeBase64 = res.data.img
                ? 'data:image/jpeg;base64, ' + res.data.img
                : '';
            this.token = res.data.token || '';
            this.expirationTime = res.data.expirationTime;
            if (res.data.claimInfo) {
              this.claimInfo = res.data.claimInfo;
            }
            this.startQRCodePolling();
          } else {
            var tipss = '授权二维码获取失败[' + (res.data.msg?res.data.msg:"未知错误") + ']，请稍后点击重新获取！';
            this.showQRCodeLoadFailure(tipss);
          }
        } else {
          // Notify({type: 'danger', message: res.message?res.message:"信息错误"});
          var tips = '授权二维码获取失败[' + (res.message?res.message:"未知错误") + ']，请点击重新获取！';
          this.showQRCodeLoadFailure(tips);
        }
      }).catch((error)=>{
        if (this.pageDestroyed || axios.isCancel(error)) {
          return;
        }
        this.spinning = false;
        // Notify({type: 'danger', message: "接口请求失败，请刷新重新页面！"});
        this.showQRCodeLoadFailure('接口请求失败，请点击重新获取！');
      }).finally(()=>{
        if (this.qrCodeRequestCancelSource === cancelSource) {
          this.qrCodeRequestCancelSource = null;
        }
        if (!this.pageDestroyed) {
          this.spinning = false;
        }
      });
    },
    showQRCodeLoadFailure(message) {
      if (this.pageDestroyed) {
        return;
      }
      this.qrCodeErrorMessage = message;
      this.startQRCodeRetryCooldown();
      Dialog.alert({
        title: '提示',
        message: message,
      }).catch(() => {
        // alert 被页面销毁等外部行为关闭时，保留页面内的显式重试入口
      });
    },
    startQRCodeRetryCooldown() {
      clearTimeout(this.qrCodeRetryTimer);
      this.qrCodeRetryCoolingDown = true;
      this.qrCodeRetryTimer = setTimeout(() => {
        this.qrCodeRetryTimer = null;
        if (!this.pageDestroyed) {
          this.qrCodeRetryCoolingDown = false;
        }
      }, QR_CODE_RETRY_COOLDOWN_MS);
    },
    retryLoginQrCodeImg() {
      if (this.pageDestroyed || this.spinning || this.qrCodeRequestCancelSource
          || this.qrCodeRetryCoolingDown) {
        return;
      }
      this.loginQrCodeImg();
    },
    isStatusOnlyProtocol() {
      return STATUS_ONLY_POLLING_MODE === String(this.pollingMode).toUpperCase()
          && STATUS_ONLY_PROTOCOL_VERSION === String(this.protocolVersion).toLowerCase()
          && 'V2' === String(this.serviceVersion).toUpperCase()
          && !!this.attemptCode;
    },
    startQRCodePolling() {
      this.stopQRCodePolling();
      const generation = this.pollGeneration;
      this.scheduleQRCodePolling(QR_CODE_POLL_INTERVAL_MS, generation);
    },
    scheduleQRCodePolling(delay, generation) {
      if (this.pageDestroyed || this.resultHandled || generation !== this.pollGeneration) {
        return;
      }
      clearTimeout(this.queryQRCodeTime);
      this.queryQRCodeTime = setTimeout(() => {
        this.queryQRCodeTime = null;
        this.queryQRCode(generation);
      }, delay);
    },
    stopQRCodePolling(cancelInFlight = true) {
      clearTimeout(this.queryQRCodeTime);
      this.queryQRCodeTime = null;
      this.pollGeneration += 1;
      if (cancelInFlight) {
        this.cancelRequest('queryRequestCancelSource', '停止查询二维码状态');
      }
    },
    cancelRequest(sourceName, reason) {
      const cancelSource = this[sourceName];
      if (cancelSource) {
        cancelSource.cancel(reason);
        this[sourceName] = null;
      }
    },
    queryQRCode(generation) {
      if (this.pageDestroyed || this.resultHandled
          || generation !== this.pollGeneration || this.queryInFlight) {
        return;
      }
      console.log("queryQRCode start");
      this.queryInFlight = true;
      let shouldContinuePolling = true;
      const cancelSource = axios.CancelToken.source();
      this.queryRequestCancelSource = cancelSource;
      const query = {claimCode: this.claimCode};
      if (this.token) {
        query.token = this.token;
      }
      if (this.isStatusOnlyProtocol()) {
        query.attemptCode = this.attemptCode;
      }
      getQueryQRCode(query, {cancelToken: cancelSource.token}).then(res => {
        if (this.pageDestroyed || generation !== this.pollGeneration) {
          shouldContinuePolling = false;
          return;
        }
        if (200 === res.code) {
          if (this.isStatusOnlyProtocol()) {
            shouldContinuePolling = this.handleStatusOnlyResponse(res.data || {});
          } else {
            shouldContinuePolling = this.handleLegacyPollingResponse(res.data || {});
          }
        }else {
          Notify({type: 'danger', message: res.message?res.message:"信息错误"});
        }
      }).catch((error)=>{
        if (this.pageDestroyed || axios.isCancel(error)) {
          shouldContinuePolling = false;
          return;
        }
        Notify({type: 'danger', message: "接口请求失败，请刷新重新页面！"});
      }).finally(()=>{
        if (this.queryRequestCancelSource === cancelSource) {
          this.queryRequestCancelSource = null;
        }
        this.queryInFlight = false;
        if (shouldContinuePolling && !this.pageDestroyed && !this.resultHandled
            && generation === this.pollGeneration) {
          this.scheduleQRCodePolling(QR_CODE_POLL_INTERVAL_MS, generation);
        }
      });
    },
    handleStatusOnlyResponse(data) {
      const code = String(data.code || '');
      this.attemptStatus = String(data.attemptStatus || '').toUpperCase();
      const terminal = true === data.terminal
          || TERMINAL_ATTEMPT_STATUS.indexOf(this.attemptStatus) !== -1;
      if ('200' === code) {
        const taskAccepted = ['SCANNED', 'DATA_SUBMITTED', 'RUNNING',
          'CALLBACK_RECEIVED', 'PENDING_REVIEW'].indexOf(this.attemptStatus) !== -1;
        this.showAuthorizationSuccess(taskAccepted
            ? '扫码成功，截图任务处理中'
            : data.msg);
        return false;
      }
      if ('204' === code || terminal) {
        this.showAuthorizationFailure(
            this.readableFailureMessage(data.msg),
            {path: '/claim/examSelect'}
        );
        return false;
      }
      if ('201' !== code) {
        console.log(data);
      }
      return true;
    },
    handleLegacyPollingResponse(data) {
      const code = String(data.code || '');
      if ('200' === code) {
        this.showAuthorizationSuccess(data.msg);
        return false;
      }
      if ('204' === code || '400' === code) {
        // 不在状态查询响应中直接创建新二维码。用户回到授权入口后显式重试，
        // 避免迟到响应和多标签页共同生成新的会话。
        this.showAuthorizationFailure(
            this.readableFailureMessage(data.msg),
            {path: '/claim/examSelect'}
        );
        return false;
      }
      if ('555' === code) {
        this.showAuthorizationFailure(
            '授权失败，请手动上传考试截图',
            {path: '/claim/claimInsert', query: {claimCode: this.claimCode}}
        );
        return false;
      }
      console.log(data);
      return true;
    },
    readableFailureMessage(message) {
      const readableMessage = message || '授权失败，请重新授权！';
      return readableMessage.replace(/token/gi, '二维码');
    },
    showAuthorizationSuccess(statusMessage) {
      if (this.resultHandled) {
        return;
      }
      this.resultHandled = true;
      this.stopQRCodePolling(false);
      Dialog.alert({
        title: '提示',
        message: (statusMessage || '授权成功')
            + '，理赔进度您可通过“理赔服务--查询 修改 扫码”功能进行操作',
      }).then(() => {
        if (!this.pageDestroyed) {
          this.$router.push("/claim/policySelect");
        }
      });
    },
    showAuthorizationFailure(message, route) {
      if (this.resultHandled) {
        return;
      }
      this.resultHandled = true;
      this.stopQRCodePolling(false);
      Dialog.alert({
        title: '提示',
        message: message,
      }).then(() => {
        if (!this.pageDestroyed) {
          this.$router.push(route);
        }
      });
    },

    copyUrl() {
      // 复制到粘贴板
      const input = document.createElement('input')
      input.setAttribute('readonly', 'readonly')
      let url= window.location.href
      input.setAttribute('value', url)
      document.body.appendChild(input)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        Notify({type: 'success', message: "链接地址已复制！"});
      }
      document.body.removeChild(input)
    }

  },
  // 在离开这个页面的时候，（比如路由跳转到别的页面）必须要清除一下这个定时器，定时器不手动清除的话，会一直存在并执行
  // 直到我们的项目服务停掉，或者关机。所以适当时候清除定时器是非常有必要的。不然耗费性能，且容易造成代码混乱
  beforeDestroy() {
    this.pageDestroyed = true;
    clearTimeout(this.qrCodeRetryTimer);
    this.qrCodeRetryTimer = null;
    this.stopQRCodePolling();
    this.cancelRequest('qrCodeRequestCancelSource', '二维码页面已销毁');
  },
}

</script>
